import { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "../../../../globals/backend/authClient";
import { getStorage, ref, uploadBytes } from "../../../../globals/backend/storageClient";
import axios from "axios";
import Selecter from "../elements/selecter";
import HandleFile from "../elements/handlefile";
import Dashboard_Loader from "../navigation/dashboard_loader";
import { insertTicket, insertComment } from "../../../../globals/backend/ticketsApi";

function Ticket_Crea({ navOpened }) {


    const [email, setEmail] = useState(null);
    const auth = getAuth();
    const [nome, setNome] = useState('');
    const [formemail, setFormEmail] = useState('');
    const [formtitle, setFormTitle] = useState('');
    const [cellulare, setCellulare] = useState('');
    const [messaggio, setMessaggio] = useState('');
    const [priorita, setPriorita] = useState('');
    const [tipoSWHW, setTipoSWHW] = useState('');

    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    const [showLoader, setShowLoader] = useState(false);


    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setEmail(user?.email ?? null);
        });
        return () => unsubscribe();
    }, [auth]);

    const autore = `${email}`;

    const [emailData, setEmailData] = useState({
        to: 'cosmin.stoica@scanteq.com',
        subject: `E STATO APERTO UN NUOVO TICKET`,
    });

    const [emailDataValentin, setEmailDataValentin] = useState({
        to: 'valentin.drogoreanu@scanteq.com',
        subject: `E STATO APERTO UN NUOVO TICKET`,
    });


    const custom = 'Sc38ahD38sW31Hshue';
    const sendEmail = async () => {
        try {
            const response = await axios.post('https://scanteq.com/php/send-email.php', emailData,
                {
                    headers: {
                        'Custom-Header': custom,
                    },
                });
        } catch (error) {
            console.error('Errore nell\'invio dell\'e-mail:', error);
        }
        try {
            const responseValentin = await axios.post('https://scanteq.com/php/send-email.php', emailDataValentin,
                {
                    headers: {
                        'Custom-Header': custom,
                    },
                });
        } catch (error) {
            console.error('Errore nell\'invio dell\'e-mail:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const conferma = window.confirm("Sei sicuro di voler creare nuovo ticket?");

        if (!conferma) {
            return;
        }

        const data = {
            Nome: nome,
            Messaggio: encodeURIComponent(messaggio),
            Autore: autore,
            Email: formemail,
            Titolo: formtitle,
            Tipo: tipoSWHW,
            Priorita: priorita === "Normale" ? 0 : priorita === "Importante" ? 1 : priorita === "Urgente" ? 2 : 0,
            Cell: encodeURIComponent(cellulare),
            Stato: '0'
        };

        const updatedEmailData = {
            ...emailData,
            text: `Nuovo ticket da ${autore} \n Nome: ${nome} \n Titolo: ${formtitle}`,
        };

        const updatedEmailDataValentin = {
            ...emailDataValentin,
            text: `Nuovo ticket da ${autore} \n Nome: ${nome} \n Titolo: ${formtitle}`,
        };

        if (email !== "admin@auth.com") {
            setEmailData({ ...updatedEmailData });
            setEmailDataValentin(updatedEmailDataValentin);
            //sendEmail();
        }

        try {
            const insertedTicket = await insertTicket(data);
            const ticketId = insertedTicket.ID;

            if (uploadedFiles.length > 0) {
                await uploadFilesToFirebase(uploadedFiles, ticketId);
            }

            await insertComment({
                Nome: nome,
                Messaggio: encodeURIComponent(messaggio),
                Autore: autore,
                ID_Ticket: ticketId
            });

            handleSuccessMessage();
            setNome("");
            setFormEmail("");
            setCellulare("");
            setMessaggio("");
            setFormTitle("");
        } catch (error) {
            handleErrorMessage();
            console.error('Errore nella richiesta al server:', error);
        }        
    };

    const handleSuccessMessage = () => {
        setShowSuccessMessage(true);
        setTimeout(() => setShowSuccessMessage(false), 2000); // Nasconde il messaggio di successo dopo 2 secondi
    };

    const handleErrorMessage = () => {
        setShowErrorMessage(true);
        setTimeout(() => setShowErrorMessage(false), 2000); // Nasconde il messaggio di errore dopo 2 secondi
    };


    const handleNomeChange = (e) => {
        setNome(e.target.value);
    };


    const handleFormEmailChange = (e) => {
        setFormEmail(e.target.value);
    };

    const handleFormTitleChange = (e) => {
        setFormTitle(e.target.value);
    };

    const handleCellulareChange = (e) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/\D/g, ''); // Rimuove tutti i caratteri non numerici

        // Aggiorna il valore dell'input con solo caratteri numerici
        setCellulare(numericValue);
    };
    const handleMessaggioChange = (e) => {
        setMessaggio(e.target.value);
    };


    const Choices1 = [
        {
            icon: '❗️',
            description: 'Urgente'
        },
        {
            icon: '⚠️',
            description: 'Importante'
        },
        {
            icon: '✅',
            description: 'Normale'
        }
    ];

    const Choices2 = [
        {
            icon: '💻',
            description: 'Software'
        },
        {
            icon: '🔧',
            description: 'Hardware'
        }
    ];



    const [uploadedFiles, setUploadedFiles] = useState([]);


    const handleCaricaFilesReturn = (files) => {
        setUploadedFiles(files);
        console.log('Files caricati:', files);
    };

    const uploadFilesToFirebase = async (files, ticketId) => {
        const storage = getStorage();
        setShowLoader(true);
        for (let file of files) {
            const storageRef = ref(storage, `ticket/${ticketId}/${file.name}`);
            try {
                await uploadBytes(storageRef, file);
                console.log(`File ${file.name} caricato con successo.`);
            } catch (error) {
                console.error(`Errore nel caricamento del file ${file.name}:`, error);
            }
        }
        setUploadedFiles([]);
        setShowLoader(false);
    };


    return (
        <>
            <div className={`CreaTicket_MainDiv ${navOpened ? "padding-leftTickets" : ""}`}>
                <form class="formToCreateTicket " onSubmit={handleSubmit}>
                    <p class="titleToCreateTicket">Crea Ticket </p>
                    <div className="formToCreateTicketUpbar">
                        <p class="messageToCreateTicket">Inserisci i dati e crea un nuovo ticket </p>
                        <HandleFile AlreadyFiles={uploadedFiles} handleCaricaFilesReturn2={handleCaricaFilesReturn} />
                    </div>
                    <div className='formToCreateTicket-div_upper height100'>
                        <div className='formToCreateTicket-div '>
                            <Selecter Status="Priorità" Choices={Choices1} setSelection={setPriorita}></Selecter>
                            <Selecter Status="Tipo" Choices={Choices2} setSelection={setTipoSWHW}></Selecter>
                            <label>
                                <input class="inputToCreateTicket" type="text" placeholder="" required value={nome}
                                    onChange={handleNomeChange} />
                                <span>Nome</span>
                            </label>

                            <label>
                                <input class="inputToCreateTicket" type="email" placeholder="" required value={formemail}
                                    onChange={handleFormEmailChange} />
                                <span>Email</span>
                            </label>
                            <label>
                                <input

                                    value={cellulare}
                                    onChange={handleCellulareChange}
                                    class="inputToCreateTicket"
                                    type="phone"
                                    placeholder=""
                                    required
                                    inputmode="numeric"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                                />
                                <span>Numero di telefono</span>
                            </label>
                            <label>
                                <input class="inputToCreateTicket" type="text" placeholder="" required value={formtitle}
                                    onChange={handleFormTitleChange} maxLength="48" />
                                <span>Titolo</span>
                            </label>
                        </div>

                        <div className='formTicket-secondPart'>
                            <label>
                                <textarea
                                    value={messaggio}
                                    onChange={handleMessaggioChange}
                                    class="inputToCreateTicket maxinputToCreateTicket"
                                    placeholder=""
                                    required
                                    rows="4"
                                ></textarea>
                                <span>Messaggio</span>
                            </label>
                        </div>
                    </div>
                    <button class="submitToCreateTicket" >Invia</button>
                </form>
            </div>
            <div className='creaticketdivnuovo'>
                {showSuccessMessage && (
                    <div className={`success-message show`}>
                        Richiesta inviata con successo
                    </div>
                )}
                {showErrorMessage && (
                    <div className={`error-message show`}>
                        Richiesta non inviata con successo
                    </div>
                )}
            </div>
            {showLoader && <Dashboard_Loader />}
        </>
    );
};

export default Ticket_Crea;
